import React, { Component } from 'react';
import { Link, Switch, Route, withRouter, Redirect } from 'react-router-dom';
import { Container } from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import has from "mout/object/has";

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as usersActionCreators from '../../redux/modules/users'
import { unsetCompareMode } from '../../redux/modules/assessment'
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'

import Dashboard from '../../views/Dashboard/';
import {
  CreateUsersContainer,
  ManageGroupsContainer,
  CreateContentContainer,
  ManageContentContainer,
  AssignmentsManageContainer,
  AssignmentsViewContainer,
  ManageUsersContainer,
  AssignmentViewContainer,
  AssignmentItemViewContainer,
  KnowledgeMapContainer,
  ManageSetsContainer,
  AssessmentDashboardContainer,
  LoaderAssessmentDashboardContainer,
  AssessmentTestingContainer,
  AssessmentReportContainer,
  ManageEducatorsContainer,
  InvitesContainer,
  ManageStudentsContainer,
  RegisterWithCodeContainer,
  ResetsContainer,
  AuthorContainer,
  AssessPrintContainer,
  SignInContainer,
} from '../../containers'
// import AuthorContainer from '../AuthorContainer';
import {
  AssessNotFound,
  UploadCSVContainer,
} from '../../components/Assessment'
import {
  UserProfile,
  UserProfileEdit,
  UserProfilePassword,
} from '../../components/Users'
import districtAdmin from '../../helpers/users/testing/districtAdmin';
import devMode from '../../config/devMode';
import {
  Licenses
} from '../../components/Users/Licenses'
import { BookPrintContainer } from '../../components/BookPrint'
import getHomePath from '../../helpers/users/getHomePath';
import Helpdesk from './../Helpdesk'
import queryString from "query-string";

// Handles routing for all containers
class Full extends Component {
  constructor(props) {
    super(props)
    this.state = {
      HeaderTitle: '',
      subTestSetId: null,
      toggle: false
    };
    this.AssessmentHeaderDetails = this.AssessmentHeaderDetails.bind(this);
  }
  AssessmentHeaderDetails(HeaderTitle, subTestSetId) {
    this.setState({ HeaderTitle, subTestSetId });
  }

  componentWillReceiveProps(nextProps) {
    let path = (this.props.location !== "") ? this.props.location.pathname : '';
    if (path.indexOf("/assessment/") > -1) {
      let toggle = this.state.toggle;
      // this.setState({ toggle: !toggle });
    } else {

      if (this.props.isCompare === true) {
        this.props.unsetCompareMode(false);
      }
    }
  }


  render() {

    const { userObj } = this.props
    const redirectPath = userObj ? getHomePath(this.props.userObj,this.props.userLicenses) : '/profile'
    const user = devMode && !this.props.user ? districtAdmin : this.props.user
    let path = (this.props.location !== "") ? this.props.location.pathname : '';
    let gua = userObj && userObj.id
    let selectedStudent = '';
    if (path.indexOf("/assessment/") > -1) {
      if (this.props.location.search) {
        const qs = queryString.parse(this.props.location.search);
        if (this.props.location && this.props.location.pathname.indexOf("/assessment/dashboard/") > -1) {

          if (has(qs, "gua")) {
            gua = qs.gua;
          }
          if (has(qs, "s")) {
            selectedStudent = qs.s;
          }
        } else {
          let pathSplit = path.split("/");
          if (pathSplit.length > 2) {
            gua = pathSplit[3];
          }
          if (has(qs, "s")) {
            selectedStudent = qs.s;
          }
        }

      }
    }
    // if there isn't a signed in user, then only access content not requiring auth
    let routes = (
      <Switch>
        <Route path='/invites/:inviteId' render={(props) => <InvitesContainer {...props} />} />
        <Route path='/register/:code' render={(props) => <RegisterWithCodeContainer {...props} />} />
        <Route path='/register' render={(props) => <RegisterWithCodeContainer {...props} />} />
        {/* <Route path='/reset/:resetId' render={(props) => <ResetsContainer {...props} />} /> */}
        <Route path='/signin-username' render={(props) => <SignInContainer {...props} />} />
        <Route render={(props) => <SignInContainer {...props} />} />
      </Switch>
    )
    // if there is a signed in user, or if we're in devMode, then access main app
    if (this.props.user || devMode) {
      routes = (
        <div className="app">
          <Header {...this.props} toggle={this.state.toggle} selectedStudent={selectedStudent} gua={gua} HeaderTitle={this.state.HeaderTitle} subTestSetId={this.state.subTestSetId} loadAssessment={this.props.loadAssessment} />
          <Sidebar {...this.props} />
          <div className="app-body">
            <main className="main">
              {/*<Breadcrumb />*/}
              <Container fluid>
                <Switch>
                  <Route exact path='/' render={(props) => (<Redirect to={redirectPath} />)} />
                  <Route path='/dashboard' render={() => <Dashboard {...this.props} />} />
                  
                  <Route path='/author' render={() => <AuthorContainer {...this.props} />} />
                  <Route path='/profile/edit' render={(props) => <UserProfileEdit {...{ ...this.props, ...props, user }} />} />
                  <Route path='/profile/password' render={(props) => <UserProfilePassword {...{ ...this.props, ...props, user }} />} />
                  <Route path='/profile' render={(props) => <UserProfile {...{ ...this.props, ...props, user }} />} />
                  <Route path='/users/create' render={(props) => <CreateUsersContainer {...props} />} />
                  <Route path='/users/dev' render={(props) => <ManageUsersContainer {...props} />} />
                  <Route path='/users/groups' render={(props) => <ManageGroupsContainer {...props} />} />
                  <Route path='/users/manage' render={(props) => <ManageEducatorsContainer {...props} />} />
                  <Route path='/users/educators' render={(props) => <ManageEducatorsContainer {...props} />} />
                  <Route path='/users/students/:activeSelection' render={(props) => <ManageStudentsContainer {...props} />} />
                  <Route path='/users/students' render={(props) => <ManageStudentsContainer {...props} />} />
                  <Route path='/users/licenses' render={(props) => <Licenses {...props} />} />
                  <Route path='/users/' render={(props) => <AssessNotFound {...props} />} />
                  <Route path='/author/' render={(props) => <AuthorContainer {...props} />} />
                  <Route path='/content/create' render={(props) => <CreateContentContainer {...props} />} />
                  <Route path='/content/manage' render={(props) => <ManageContentContainer {...props} />} />
                  <Route path='/content/sets/:activeSet' render={(props) => <ManageSetsContainer {...props} />} />
                  <Route path='/content/sets' render={(props) => <ManageSetsContainer {...props} />} />
                  <Route path='/content/knowledge-map/:activeNode' render={(props) => <KnowledgeMapContainer {...props} />} />
                  <Route path='/content/knowledge-map/' render={(props) => <KnowledgeMapContainer {...props} />} />
                  <Route path='/assignments/manage' render={(props) => <AssignmentsManageContainer {...props} />} />
                  <Route path='/assignments/view' render={(props) => <AssignmentsViewContainer {...props} />} />
                  <Route path='/assignments/assignment/:assignmentId/:itemId' render={(props) => <AssignmentItemViewContainer {...props} />} />
                  <Route path='/assignments/assignment/:id' render={(props) => <AssignmentViewContainer {...props} />} />
                  <Route path='/assessment/not-found' render={(props) => <AssessNotFound {...props} />} />
                  <Route path='/assessment/dashboard/:assessmentId' render={(props) => <AssessmentDashboardContainer {...props} />} />
                  <Route path='/assessment/loaderdashboard/:assessmentId' render={(props) => <LoaderAssessmentDashboardContainer {...props} />} />
                  <Route path='/assessment/testing/:userAssessmentId/:subTestSetId' render={(props) => <AssessmentTestingContainer {...props} AssessmentHeaderDetails={this.AssessmentHeaderDetails} />} />
                  <Route path='/assessment/reports/:userAssessmentId/:subTestSetId' render={(props) => <AssessmentReportContainer {...props} />} />
                  <Route path='/assessment/print/:userAssessmentId' render={(props) => <AssessPrintContainer {...props} />} />
                  <Route path='/assessment/upload/:recordType/:recordId' render={(props) => <UploadCSVContainer {...props} />} />
                  <Route path='/assessment/' render={(props) => <AssessNotFound {...props} />} />
                  <Route path='/invites/:inviteId' render={(props) => <InvitesContainer {...props} />} />
                  <Route path='/register/:code' render={(props) => <RegisterWithCodeContainer {...props} />} />
                  <Route path='/register' render={(props) => <RegisterWithCodeContainer {...props} />} />
                  {/* <Route path='/reset/:resetId' render={(props) => <ResetsContainer {...props} />} /> */}
                  <Route path='/book/print' render={(props) => <BookPrintContainer {...props} />} />
                  <Route path='/help' render={(props) => <Helpdesk {... { props, userObj }} />} />
                </Switch>
              </Container>
            </main>
            <Aside />
          </div>
          <Footer />
        </div>
      )
    }
    return (
      routes
    )
  }
}

export const mapStatetoProps = (state) => {
  return {
    user: state.users.uid,
    userObj: state.users.testUser,
    loadAssessment: state.assessment.loadAssessmentHeader,
    isCompare: state.assessment.isCompare
  }
}

export default connect(
  mapStatetoProps, (dispatch) => bindActionCreators({ ...usersActionCreators, unsetCompareMode }, dispatch)
)(withRouter(Full))


// WEBPACK FOOTER //
// ./src/containers/Full/Full.js